module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDI0IDI0Ij4KPHN0eWxlPgogICAgLnBhdGgxIHsgZmlsbDogIzAyMDIwMjsgfQo8L3N0eWxlPgo8cGF0aCBjbGFzcz0icGF0aDEiIGQ9Ik0xMiAwYy00LjE5OCAwLTggMy40MDMtOCA3LjYwMiAwIDQuMTk4IDMuNDY5IDkuMjEgOCAxNi4zOTggNC41MzEtNy4xODggOC0xMi4yIDgtMTYuMzk4IDAtNC4xOTktMy44MDEtNy42MDItOC03LjYwMnptMCAxMWMtMS42NTcgMC0zLTEuMzQzLTMtM3MxLjM0My0zIDMtMyAzIDEuMzQzIDMgMy0xLjM0MyAzLTMgM3oiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/about/location.svg
// module id = 690
// module chunks = 263791100135453